<div
  style="overflow-y: auto"
  mdbModal
  #tradeEditModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
>
  <form #tradeEditForm="ngForm" (ngSubmit)="saveClicked(tradeEditForm)" name="tradeEditForm" class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="showHideModal(false)">
          <span aria-hidden="true">×</span>
        </button>
        <div>
          <h3 class="text-center font-weight-bold" mdbTooltip="{{ transactionId }}">{{ transaction.fullName }}</h3>
        </div>
      </div>
      <div class="modal-body">
        <div class="row gx-4">
          <div class="col-md-6 mb-3">
            <label for="transactionStatus" class="d-block">Change Transaction Status</label>
            <select
              mdbInput
              [(ngModel)]="statusId"
              name="selectStatus"
              id="tStatus"
              class="form-control browser-default"
              [disabled]="!editEnabled"
              (change)="selectionChanged()"
            >
              <option *ngFor="let status of statusList" [ngValue]="status.id">
                {{ status.name }}
              </option>
            </select>
          </div>
          <div class="col-md-4 mb-3">
            <label for="overriddenDealType" class="d-block">Override Deal Type</label>
            <select
              mdbInput
              name="overriddenDealType"
              id="overriddenDealType"
              class="form-control browser-default"
              [(ngModel)]="deal.overriddenDealType"
              [disabled]="!canEditDealType()"
              (change)="overriddenDealTypeChanged()"
            >
              <option [ngValue]="null">Default</option>
              <option [ngValue]="'Cash'">Cash</option>
              <option [ngValue]="'Tom'">Tom</option>
              <option [ngValue]="'Spot'">Spot</option>
            </select>
          </div>
          <div class="col-md-2 mb-3">
            <label for="txtDealRate" class="d-block">Deal Rate</label>
            <span *ngIf="!deal" mdbTooltip="No deal linked to this transaction">
              <input
                mdbInput
                mdbValidate
                name="txtDealRate"
                type="number"
                id="txtDealRate"
                class="form-control"
                [disabled]="true"
                required
              />
            </span>
            <input
              type="number"
              id="txtDealRate"
              name="txtDealRate"
              [(ngModel)]="deal.dealRate"
              class="form-control"
              mdbInput
              mdbValidate
              *ngIf="deal"
              [disabled]="!editDealRateEnabled"
              required
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <table class="table table-sm table-bordered" mdbTable hover="true">
              <thead class="thead-light">
                <tr>
                  <th>Retries</th>
                  <th>Created</th>
                  <th>Updated</th>
                  <th>Last message</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ this.deal?.retryCount }}</td>
                  <td>{{ this.deal?.created | date: "d MMM - HH:mm" }}</td>
                  <td>{{ dealLastUpdated() }}</td>
                  <td>{{ this.deal?.lastMessage }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div *ngIf="showOverrideBox" class="row mt-3">
          <div class="col-12">
            <div class="alert alert-danger mb-0">
              <div>
                <div *ngIf="isDealNotFound">
                  <strong>Warning:</strong> Booked deal was not found. <strong>Contact CFS </strong> to confirm why the booked deal was not
                  found after booking successfully.
                </div>
                <div *ngIf="!isDealNotFound">
                  <strong>Warning:</strong> It may be safe to re-process this trade at {{ futureTimeAsDate | date: "HH:mm" }}.
                </div>
                <div class="mt-3" *ngIf="isPeriodElapsed == false">
                  <input class="form-check-input" type="checkbox" id="checkboxOverride" [(ngModel)]="override" name="checkboxOverride" />
                  <label for="checkboxOverride" class="form-check-label ml-4">Override</label>
                </div>
              </div>
              <div class="mt-3" *ngIf="override || isPeriodElapsed">
                By checking the following box you confirm that you have made sure that the trade does not exist on CFS.
                <div class="mt-2">
                  <mdb-checkbox
                    (change)="onReprocessAcknowledgementChange()"
                    [(ngModel)]="reprocessAcknowledgement"
                    name="checkboxReprocess"
                    >I want to re-process this trade</mdb-checkbox
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <div *ngIf="containsError">
              <strong>Information:</strong>
              <p *ngIf="confirmCFSStatusBtnVisible">{{ manualStatusCheckMessage }}</p>
              <p>{{ apiInfoMessageArray[1] }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer d-flex justify-content-between">
        <div *ngIf="!busy">
          <span *ngIf="canDelete(transaction) && !confirmCFSStatusBtnVisible">
            <button mdbBtn color="grey" class="btn relative waves-light" (click)="deleteTrade()">
              <mdb-icon fas icon="trash"></mdb-icon> Delete
            </button>
          </span>
        </div>
        <div *ngIf="!busy">
          <span *ngIf="canLinkPrebookedTrade(transaction) && !confirmCFSStatusBtnVisible">
            <button
              mdbBtn
              color="trakly-action"
              class="relative waves-light"
              (click)="linkPrebookedTrade()"
              mdbTooltip="Link if you confirmed with Dooya that they do have the trade on their side"
            >
              <mdb-icon fas icon="link"></mdb-icon> Link
            </button>
          </span>
          <span *ngIf="canRetryPrebooking(transaction) && !confirmCFSStatusBtnVisible">
            <button
              mdbBtn
              color="trakly-action"
              class="relative waves-light"
              (click)="retryPrebooking()"
              mdbTooltip="Retry if Dooya says the trade never came through or it's not on the bot"
            >
              <mdb-icon fas icon="redo-alt"></mdb-icon> Retry
            </button>
          </span>
          <span *ngIf="showRefreshDooyaButton()">
            <button mdbBtn color="trakly-action" class="relative waves-light" (click)="refreshDooyaStatus()">Refresh Dooya Status</button>
          </span>
          <span *ngIf="reprocessBtnVisible">
            <button mdbBtn color="trakly-action" class="relative waves-light" (click)="reprocessTrade()">Reprocess</button>
          </span>
          <button *ngIf="confirmCFSStatusBtnVisible" mdbBtn color="trakly-action" class="relative waves-light" (click)="checkCFSStatus()">
            Get Deal Status Now
          </button>

          <button
            *ngIf="!busy && saveBtnVisible && !reprocessBtnVisible"
            type="submit"
            mdbBtn
            color="trakly-action"
            class="relative waves-light"
          >
            Save
          </button>
          <button type="button" mdbBtn color="trakly" class="relative waves-light" (click)="showHideModal(false)">Close</button>
        </div>
        <div *ngIf="busy">
          {{ busyText }}
          <div *ngIf="busy" class="spinner-grow text-primary text-center" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
